import formatters from '../formatters'

const mountDefaultValues = (defaultValues) => {
  const mountedDefaultValues = defaultValues.map((defaultValue) => {
    return {
      id: defaultValue?.id,
      name: defaultValue?.name,
      email: defaultValue?.email,
      cpf: formatters.cnpjAndCpfMask(defaultValue?.cpf),
      cnpj: formatters.cnpjAndCpfMask(defaultValue?.cnpj),
      kindPerson: defaultValue?.kindPerson,
      kind: defaultValue?.kind,
      active: defaultValue?.active,
    }
  })

  return mountedDefaultValues
}

export default mountDefaultValues
